import { render } from "./Chekbox.vue?vue&type=template&id=26593aff"
import script from "./Chekbox.vue?vue&type=script&lang=js"
export * from "./Chekbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__